module.exports = __webpack_public_path__ + "static/media/frutiger-45light.2b70981d.woff";